import { useObjectUrl } from '@/hooks/useObjectUrl';

export function ImageThumb({ mediaId }: { mediaId: string }) {
  const url = useObjectUrl(mediaId);
  return (
    <div className="h-12 w-8 shrink-0 overflow-hidden rounded bg-slate-200 dark:bg-slate-700">
      {url && <img src={url} alt="" className="h-full w-full object-cover" />}
    </div>
  );
}
